import {
  LargeInput,
  LargeInputWithIconButton,
  LargeInputIconButton,
  VisibilityOnOutlineIcon,
  VisibilityOffOutlineIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ComponentProps } from "react"
import {
  useCallback,
  useState,
} from "react"

export function LargePasswordInput(props: ComponentProps<typeof LargeInput>) {
  const [
    showPassword,
    setShowPassword,
  ] = useState(false)

  const toggleShowPassword = useCallback(
    () => {
      setShowPassword(!showPassword)
    },
    [
      showPassword,
      setShowPassword,
    ],
  )

  return (
    <LargeInputWithIconButton>
      <LargeInput
        type={showPassword ? "text" : "password"}
        {...props}
      />
      <LargeInputIconButton
        placementPreset="end"
        onClick={toggleShowPassword}
      >
        {showPassword
          ? <VisibilityOffOutlineIcon />
          : <VisibilityOnOutlineIcon />
        }
      </LargeInputIconButton>
    </LargeInputWithIconButton>
  )
}
